import { FC } from "react";
import OrganizationStructureForm from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/Forms/OrganizationStructureForm";
import { PermissionsContextProvider } from "src/utils/Permissions/PermissionsContext";

interface OrganizationStructureProps {
  employeeId: string;
  companyId: string;
  setIsEdited?: (isEdited: boolean, callback?: () => void) => void;
  active?: boolean;
}

const OrganizationStructure: FC<OrganizationStructureProps> = ({
  employeeId,
  companyId,
  setIsEdited = () => null,
  active = false,
}) => {
  if (!active) {
    return null;
  }

  return (
    <PermissionsContextProvider>
      <OrganizationStructureForm
        employeeId={employeeId}
        companyId={companyId}
        setIsEdited={setIsEdited}
      />
    </PermissionsContextProvider>
  );
};

export default OrganizationStructure;
